"use client";

import React, { createContext, useContext } from "react";

import { FALLBACK_LOCALE, Locales } from "../services/i18n/settings";
import { setDayjsLocale } from "../services/dayjs";

const LocaleContext = createContext<Locales>(FALLBACK_LOCALE);

const LocaleProvider = ({ children, locale }: { children: React.ReactNode; locale: Locales;}) => {
  setDayjsLocale(locale);
  return (
    <LocaleContext.Provider value={locale}>{children}</LocaleContext.Provider>
  );
};

const useLocale = () => useContext(LocaleContext);

export default LocaleContext;
export { LocaleProvider, useLocale };
